import React, { useState } from 'react';
import { Calendar, ChevronRight } from 'lucide-react';

export const DateTimeSelection = ({
  selectedService,
  availableSlots,
  loading,
  selectedDate,
  selectedTimeSlot,
  onSelectSlot,
  customStartDate,
  onDateChange,
  onBack,
  onContinue
}) => {
  const [expandedDates, setExpandedDates] = useState(new Set());

  const toggleDateExpansion = (date) => {
    setExpandedDates((prev) => {
      const newSet = new Set(prev);
      if (newSet.has(date)) {
        newSet.delete(date);
      } else {
        newSet.add(date);
      }
      return newSet;
    });
  };

  return (
    <div className="space-y-4">
      <div className="text-center mb-6">
        <h2 className="text-xl font-semibold text-gray-900">בחר תאריך</h2>
        <p className="text-gray-600 text-sm mt-1">
          {selectedService?.name} - {selectedService?.duration} דקות
        </p>
      </div>

      <div className="mb-6">
        <div className="flex items-center gap-3 p-4 bg-white/50 rounded-xl border border-white/20">
          <Calendar className="w-5 h-5 text-rose-500" />
          <div className="flex-1">
            <input
              type="date"
              value={customStartDate || new Date().toISOString().split('T')[0]}
              onChange={onDateChange}
              min={new Date().toISOString().split('T')[0]}
              className="w-full px-3 py-2 rounded-lg border border-gray-200 focus:ring-2 focus:ring-rose-500 focus:border-transparent text-sm"
              placeholder="בחר תאריך התחלה"
            />
          </div>
          {customStartDate && (
            <div className="text-xs text-gray-600 font-medium">
              החל מ־
              {new Date(customStartDate).toLocaleDateString('he-IL', {
                day: 'numeric',
                month: 'long'
              })}
            </div>
          )}
        </div>
      </div>

      {loading ? (
        <div className="text-center py-8">
          <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-rose-500 mx-auto"></div>
          <p className="text-gray-600 mt-2 text-sm">טוען תאריכים זמינים...</p>
        </div>
      ) : availableSlots.length > 0 ? (
        <div className="space-y-3">
          {availableSlots.map((daySlots) => (
            <div key={daySlots.date} className="space-y-2">
              <button
                onClick={() => toggleDateExpansion(daySlots.date)}
                className="w-full flex items-center justify-between py-2 px-3 bg-gray-50 rounded-lg hover:bg-gray-100 transition-colors"
              >
                <span className="font-medium text-gray-900">
                  {new Date(daySlots.date).toLocaleDateString('he-IL', {
                    weekday: 'long',
                    month: 'long',
                    day: 'numeric'
                  })}
                </span>
                <div className="flex items-center gap-2">
                  <span className="text-sm text-gray-600">{daySlots.totalSlots} תורים זמינים</span>
                  <ChevronRight
                    className={`w-4 h-4 text-gray-400 transition-transform ${
                      expandedDates.has(daySlots.date) ? 'rotate-90' : ''
                    }`}
                  />
                </div>
              </button>

              {expandedDates.has(daySlots.date) && (
                <div className="grid grid-cols-3 gap-2">
                  {daySlots.availableSlots.map((slot, index) => (
                    <button
                      key={`${daySlots.date}-${slot.time}-${index}`}
                      onClick={() => onSelectSlot(daySlots.date, slot)}
                      className={`p-3 rounded-xl border-2 transition-all duration-200 text-center ${
                        selectedDate === daySlots.date && selectedTimeSlot?.time === slot.time
                          ? 'border-rose-500 bg-rose-50'
                          : 'border-gray-200 hover:border-rose-300'
                      }`}
                    >
                      <div className="text-sm font-medium text-gray-900">{slot.time}</div>
                      <div className="text-xs text-gray-600 mt-1">{slot.crewMemberName}</div>
                    </button>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      ) : (
        <div className="text-center py-8">
          <p className="text-gray-600">אין תאריכים זמינים בשבועיים הקרובים</p>
          <button onClick={onBack} className="mt-4 text-rose-600 text-sm underline">
            בחר שירות אחר
          </button>
        </div>
      )}

      <div className="flex gap-3 pt-4">
        <button
          onClick={onBack}
          className="flex-1 py-3 border border-gray-300 rounded-2xl font-semibold text-gray-700 hover:bg-gray-50"
        >
          חזור
        </button>
        <button
          onClick={onContinue}
          disabled={!selectedDate || !selectedTimeSlot}
          className="flex-1 bg-gradient-to-r from-rose-500 to-pink-500 text-white py-3 rounded-2xl font-semibold hover:shadow-lg transition-all duration-300 disabled:opacity-50 disabled:cursor-not-allowed"
        >
          המשך לאישור
        </button>
      </div>
    </div>
  );
};
